module.exports = __webpack_public_path__ + "img/logo.67dcd1a8.png";